/**
 * Соединение полей адресса с сепаратором
 * @param array - массив значений адресса
 * @param separator - сепаратор соединения значений адреса
 */
export const joinPartsOfAddress = (array: string[], separator = ', '): string =>
  array.filter((n) => n).join(separator)
